import type { BookingStep, BookingSubStep } from '../hooks/useBookingWizard';

interface BookingHeaderProps {
  step: BookingStep;
  subStep: BookingSubStep;
  isRescheduling: boolean;
}

export function BookingHeader({ step, subStep, isRescheduling }: BookingHeaderProps) {
  return (
    <div className="text-center mb-10">
      <h1 className="text-[32px] md:text-[40px] font-semibold text-[#080404] mb-3 leading-tight">
        {isRescheduling ? 'Remarcar Agendamento' : 'Novo Agendamento'}
      </h1>
      <p className="text-base md:text-[18px] text-[#64748b] font-normal">
        {step === 1 && subStep === 1 && 'Passo 1/4 - Escolha o estado'}
        {step === 1 && subStep === 2 && 'Passo 2/4 - Escolha a cidade'}
        {step === 1 && subStep === 3 && 'Passo 3/4 - Escolha a loja'}
        {step === 1 && subStep === 4 && 'Passo 4/4 - Escolha a data e horário'}
        {step === 2 && 'Preencha seus dados pessoais'}
        {step === 3 && 'Informe os dados do veículo'}
        {step === 4 && 'Revise as informações'}
        {step === 5 && 'Agendamento confirmado!'}
      </p>
    </div>
  );
}
